import { render, staticRenderFns } from "./SettingAccountMail.vue?vue&type=template&id=c2243218"
import script from "./SettingAccountMail.vue?vue&type=script&lang=js"
export * from "./SettingAccountMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports